import { hasWindow } from "@omni/utils/dom.utils";
import { cn } from "@omni/utils/styles";

import { Messages } from "@/components/General/Messages/messages.container";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { StoreSearchInput } from "../StoreSearchInput/storeSearchInput";
import { SearchItem } from "../StoreSearchInput/storeSearchInput.types";
import {
    STORE_LOCATOR_MOBILE_INPUT_TYPES,
    STORE_LOCATOR_MOBILE_MESSAGE_ID
} from "./storeLocatorMobile.config";

type Props = {
    onUseLocation: (latitude: number, longitude: number) => void;
    onSelect: (value: SearchItem | null) => void;
    onSubmitClick: (value?: string) => void;
};

const StoreLocatorMobile = ({
    onUseLocation,
    onSelect,
    onSubmitClick
}: Props) => {
    const { t } = useGranite();

    return (
        <div className={cn("tw:bg-primary tw:py-8 tw:px-4")}>
            <h2 className={cn("tw:text-white")}>
                {t("storelocator.mobile.title")}
            </h2>
            <Messages messageid={STORE_LOCATOR_MOBILE_MESSAGE_ID} />
            <span className={cn("tw:text-white tw:mb-2 tw:block")}>
                {t("storelocator.mobile.description")}
            </span>
            <div className={cn("tw:flex tw:flex-col")}>
                <StoreSearchInput
                    messageId={STORE_LOCATOR_MOBILE_MESSAGE_ID}
                    clearable={false}
                    itemsToRetrieve={STORE_LOCATOR_MOBILE_INPUT_TYPES}
                    placeholder={t("form.searchstore.input.placeholder")}
                    loadingText={t("form.searchstore.loading")}
                    menuPortalTarget={hasWindow() ? document.body : null}
                    aria-label={t("storelocator.mobile.submit")}
                    onUseLocation={onUseLocation}
                    onSelect={onSelect}
                    onSubmitClick={onSubmitClick}
                >
                    <StoreSearchInput.Input className={cn("tw:w-full")} />
                    <StoreSearchInput.Location
                        className={cn(
                            "tw:text-white tw:hover:text-white tw:active:text-white"
                        )}
                    />
                    <StoreSearchInput.SearchButton
                        color={"gray"}
                        className={cn(
                            "tw:flex tw:gap-1 tw:justify-center tw:mt-4! tw:items-center"
                        )}
                    >
                        <div className={cn("tw:w-fit tw:whitespace-nowrap")}>
                            {t("storelocator.mobile.submit")}
                        </div>
                        <i className={cn("la-md las la-angle-right")} />
                    </StoreSearchInput.SearchButton>
                </StoreSearchInput>
            </div>
        </div>
    );
};

export default StoreLocatorMobile;
